module.exports = __webpack_public_path__ + "img/富源县妇幼保健计划生育服务中心.73c50689.png";